const currentVersion = 'beta_0.0.1'

export default {
  currentVersion,
}
